import './Flag.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';

type FlagProps = {
    country: string;
};

const Flag:any = ({ country }: FlagProps) => {
    const { t } = useTranslation();

    const normalizedCountry = country?.toUpperCase();

    const getFlagSrc = (countryCode: string) => `/assets/flags/${countryCode}.png`;

    switch (normalizedCountry) {
        case 'ERK':
        case '11':
            return t('tutorial');
        case 'RU':
            return <img className="flag" src={getFlagSrc('RUS')} alt="RU" data-testid="flag-ru" />;
        case 'CC':
            return <img className="flag" src={getFlagSrc('AUS')} alt="CC" data-testid="flag-cc" />;
        default:
            return <img className="flag" src={getFlagSrc(normalizedCountry)} alt={normalizedCountry} data-testid={`flag-${normalizedCountry.toLocaleLowerCase()}`} />;
    }
};

export default Flag;
